export default "__VITE_ASSET__6e328d40__"